import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TABS } from '.';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import useThrowAsyncError from '../../hooks/useThrowAsyncError';
import ContentBody from '../../layout/content/ContentBody';
import ContentHeader from '../../layout/content/ContentHeader';
import {
  withScrollThreshold,
  WithScrollThresholdProps,
} from '../../shared-components/elementis/hoc/withScrollThreshold';
import useGroupInviteToasts from '../my-teachers/hooks/useGroupInviteToasts';
import { fetchUserModules } from './api/methodsApi';
import Catalogue from './components/Catalogue';
import UserRoleAlert from './components/UserRoleAlert';

import Page from '@pelckmans/elementis/components/page';
import Tabs from '@pelckmans/elementis/components/tabs';

interface CataloguePageProps extends WithScrollThresholdProps {}

function CataloguePage({ pastThreshold }: CataloguePageProps) {
  const { REACT_APP_P_STUDIO_GROUP } = process.env;
  const { t } = useTranslation();
  const handleError = useThrowAsyncError();
  const [demoModules, setDemoModules] = useState<string[]>([]);

  useDocumentTitle(t('PAGES.MY_METHODS.CATALOGUE.DOCUMENT_TITLE'));

  useGroupInviteToasts();

  const fetchModules = useCallback(async () => {
    const fetchedUserModules = await fetchUserModules(REACT_APP_P_STUDIO_GROUP);

    try {
      const demoModules = fetchedUserModules.filter(module => module.isDemo);
      setDemoModules(demoModules.map(module => module.id));
    } catch (err) {
      handleError(err);
    }
  }, [REACT_APP_P_STUDIO_GROUP, handleError]);

  useEffect(() => {
    fetchModules();
  }, [fetchModules]);

  return (
    <>
      <ContentHeader
        cover={
          <Page.Header
            density={pastThreshold ? 'compact' : 'normal'}
            headerText={t('PAGES.MY_METHODS.HEADER.TITLE')}
            tabs={
              <Tabs.TabList aria-label={t('PAGES.MY_METHODS.HEADER.TAB_LIST.A11Y_LABEL')}>
                <Tabs.Tab id={TABS.DASHBOARD}>{t('PAGES.MY_METHODS.HEADER.TAB_LIST.TABS.MY_METHODS')}</Tabs.Tab>
                <Tabs.Tab id={TABS.CATALOGUE}>{t('PAGES.MY_METHODS.HEADER.TAB_LIST.TABS.CATALOGUE')}</Tabs.Tab>
              </Tabs.TabList>
            }
          />
        }
      />
      <ContentBody alerts={<UserRoleAlert />}>
        <Tabs.TabsContent>
          <Tabs.TabPanel id={TABS.CATALOGUE}>
            <Catalogue demoModules={demoModules} />
          </Tabs.TabPanel>
        </Tabs.TabsContent>
      </ContentBody>
    </>
  );
}

export default withScrollThreshold(CataloguePage);
